export const formatToTemporaryState = (obj) => {
  const {
    partner: { id: partnerId, name: partnerName, photoUrl: partnerPhotoUrl },
    shop: { address, id, name, shortName },
    timeSlot: { from, to },
  } = obj;
  return {
    ...obj,
    partner: {
      id: partnerId,
      name: partnerName,
      photoUrl: partnerPhotoUrl,
    },
    shop: {
      address,
      id,
      name,
      shortName,
    },
    timeSlot: {
      from,
      to,
    },
  };
};
